import Vue from 'vue'
import Vuex from 'vuex'
import token from './token/index'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {

  },
  mutations: {

  },
  actions: {

  },
  modules: {
    token: token
  }
})
